import { render } from "./About.vue?vue&type=template&id=54bddd0a"
const script = {}
script.render = render

export default script